import type { I18n as VueI18n, Locale } from 'vue-i18n';
import { createI18n } from 'vue-i18n';
import { DEFAULT_LANGUAGE } from '@/common/utils/constants';
import { getLanguageFromClient } from '@/common/utils/language';
import zhCN from '@/common/locales/zh-CN.yaml';
import enUS from '@/common/locales/en-US.yaml';

export type I18n = VueI18n<NonNullable<unknown>, NonNullable<unknown>, NonNullable<unknown>, Locale, false>;

const i18n = createI18n({
  locale: getLanguageFromClient(),
  fallbackLocale: {
    'en-US': [DEFAULT_LANGUAGE],
  },
  legacy: false,
  allowComposition: true,
  messages: {
    'zh-CN': zhCN,
    'en-US': enUS,
  },
}) as I18n;

export default i18n;
